const produtosData = [
    {
        id: 1,
        product: require('@/assets/images/product-mobagile/midea-logo.png'),
        discount: 10,
        name: 'Midea',
        oldprice: 450,
        newprice: 80.544,
        feature: ['Tag Classificação 09', 'Tag Testes', 'Tag Promocional', 'Tag Novidades'],
        specification: [{
            key: 'Tamanho',
            value: 'M'
        },
            {
                key: 'Cor',
                value: 'Vermelho'
            }],
        images: [require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-3.png'), require('@/assets/images/product/img-6.png')],
        colorVariant: [{
            key: 'Vermelho',
            value: require('@/assets/images/product/img-1.png')
        },
            {
                key: 'Preto',
                value: require('@/assets/images/product/img-1.png')
            }]
    },
    {
        id: 2,
        product: require('@/assets/images/product-mobagile/carrier-logo.png'),
        name: 'Carrier Extra Power',
        discount: 20,
        oldprice: 225,
        newprice: 75.801,
        feature: ['Tag Classificação 09', 'Tag Testes', 'Tag Promocional', 'Tag Novidades'],
        specification: [{
            key: 'Tamanho',
            value: 'M'
        },
            {
                key: 'Cor',
                value: 'Light Blue'
            }],
        images: [require('@/assets/images/product/img-2.png'), require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-3.png')],
        colorVariant: [{
            key: 'Vermelho',
            value: require('@/assets/images/product/img-2.png')
        },
            {
                key: 'Amarelo',
                value: require('@/assets/images/product/img-2.png')
            },
            {
                key: 'Verde',
                value: require('@/assets/images/product/img-2.png')
            }]
    },
    {
        id: 3,
        product: require('@/assets/images/product-mobagile/samsung-logo.png'),
        discount: 14,
        name: 'Samsung',
        oldprice: 177,
        newprice: 94.877,
        feature: ['Tag Classificação 09', 'Tag Testes', 'Tag Promocional', 'Tag Novidades'],
        specification: [{
            key: 'Tamanho',
            value: 'M'
        },
            {
                key: 'Cor',
                value: 'Preto'
            }],
        images: [require('@/assets/images/product/img-3.png'), require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-2.png')],
        colorVariant: [{
            key: 'Preto',
            value: require('@/assets/images/product/img-3.png')
        },
            {
                key: 'Amarelo',
                value: require('@/assets/images/product/img-3.png')
            }]
    },
    {
        id: 3,
        product: require('@/assets/images/product-mobagile/daikin-logo.png'),
        discount: 14,
        name: 'Black Color T-shirt',
        oldprice: 177,
        newprice: 50.444,
        feature: ['Tag Classificação 09', 'Tag Testes', 'Tag Promocional', 'Tag Novidades'],
        specification: [{
            key: 'Tamanho',
            value: 'M'
        },
            {
                key: 'Cor',
                value: 'Preto'
            }],
        images: [require('@/assets/images/product/img-3.png'), require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-2.png')],
        colorVariant: [{
            key: 'Preto',
            value: require('@/assets/images/product/img-3.png')
        },
            {
                key: 'Amarelo',
                value: require('@/assets/images/product/img-3.png')
            }]
    },
];



const clothsData = [
    {
        id: 1,
        product: require('@/assets/images/product/img-1.png'),
        discount: 10,
        name: 'Produto Testes 0088',
        oldprice: 450,
        newprice: 405,
        feature: ['Tag Classificação 09', 'Tag Testes', 'Tag Promocional', 'Tag Novidades'],
        specification: [{
            key: 'Tamanho',
            value: 'M'
        },
        {
            key: 'Cor',
            value: 'Vermelho'
        }],
        images: [require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-3.png'), require('@/assets/images/product/img-6.png')],
        colorVariant: [{
            key: 'Vermelho',
            value: require('@/assets/images/product/img-1.png')
        },
        {
            key: 'Preto',
            value: require('@/assets/images/product/img-1.png')
        }]
    },
    {
        id: 2,
        product: require('@/assets/images/product/img-2.png'),
        name: 'Produto Testes 0977',
        discount: 20,
        oldprice: 225,
        newprice: 175,
        feature: ['Tag Classificação 09', 'Tag Testes', 'Tag Promocional', 'Tag Novidades'],
        specification: [{
            key: 'Tamanho',
            value: 'M'
        },
        {
            key: 'Cor',
            value: 'Light Blue'
        }],
        images: [require('@/assets/images/product/img-2.png'), require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-3.png')],
        colorVariant: [{
            key: 'Vermelho',
            value: require('@/assets/images/product/img-2.png')
        },
        {
            key: 'Amarelo',
            value: require('@/assets/images/product/img-2.png')
        },
        {
            key: 'Verde',
            value: require('@/assets/images/product/img-2.png')
        }]
    },
    {
        id: 3,
        product: require('@/assets/images/product/img-3.png'),
        discount: 14,
        name: 'Produto Testes 7777',
        oldprice: 177,
        newprice: 152,
        feature: ['Tag Classificação 09', 'Tag Testes', 'Tag Promocional', 'Tag Novidades'],
        specification: [{
            key: 'Tamanho',
            value: 'M'
        },
        {
            key: 'Cor',
            value: 'Preto'
        }],
        images: [require('@/assets/images/product/img-3.png'), require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-2.png')],
        colorVariant: [{
            key: 'Preto',
            value: require('@/assets/images/product/img-3.png')
        },
        {
            key: 'Amarelo',
            value: require('@/assets/images/product/img-3.png')
        }]
    },
    {
        id: 4,
        product: require('@/assets/images/product/img-4.png'),
        name: 'Produto Testes 004',
        discount: 5,
        oldprice: 150,
        newprice: 145,
        feature: ['Tag Classificação 09', 'Tag Testes', 'Tag Promocional', 'Tag Novidades'],
        specification: [{
            key: 'Tamanho',
            value: 'M'
        },
        {
            key: 'Cor',
            value: 'Azul'
        }],
        images: [require('@/assets/images/product/img-4.png'), require('@/assets/images/product/img-4.png'), require('@/assets/images/product/img-4.png'), require('@/assets/images/product/img-4.png')],
        colorVariant: [{
            key: 'Blue',
            value: require('@/assets/images/product/img-4.png')
        },
        {
            key: 'Pink',
            value: require('@/assets/images/product/img-4.png')
        }]
    },
    {
        id: 5,
        product: require('@/assets/images/product/img-5.png'),
        discount: 14,
        name: 'Produto Testes 8888',
        oldprice: 177,
        newprice: 152,
        feature: ['Tag Classificação 09', 'Tag Testes', 'Tag Promocional', 'Tag Novidades'],
        specification: [{
            key: 'Tamanho',
            value: 'M'
        },
        {
            key: 'Cor',
            value: 'Rosa'
        }],
        images: [require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-2.png'), require('@/assets/images/product/img-3.png')],
        colorVariant: [{
            key: 'Pink',
            value: require('@/assets/images/product/img-5.png')
        },
        {
            key: 'Amarelo',
            value: require('@/assets/images/product/img-5.png')
        }]
    },
    {
        id: 6,
        product: require('@/assets/images/product/img-6.png'),
        discount: 22,
        name: 'Produto Testes 7777',
        oldprice: 240,
        newprice: 225,
        feature: ['Tag Classificação 09', 'Tag Testes', 'Tag Promocional', 'Tag Novidades'],
        specification: [{
            key: 'Tamanho',
            value: 'M'
        },
        {
            key: 'Cor',
            value: 'Verde'
        }],
        images: [require('@/assets/images/product/img-6.png'), require('@/assets/images/product/img-3.png'), require('@/assets/images/product/img-2.png'), require('@/assets/images/product/img-1.png')],
        colorVariant: [{
            key: 'Preto',
            value: require('@/assets/images/product/img-6.png')
        },
        {
            key: 'Amarelo',
            value: require('@/assets/images/product/img-6.png')
        }]
    }
];

export { clothsData, produtosData };
